// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".virtual-class-card {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  border-radius: 0.5rem;\n}\n.virtual-class-card img {\n  aspect-ratio: 3/4;\n  object-fit: cover;\n}\n.virtual-class-card img.contain_img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  opacity: 0.3;\n  transform: scale(0.8);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
